import { DataCollectorInstance, TransactionCollector } from '@scfe-common/core';
import { handleResponseData } from '../../utils';
import { ActionType, RequestState } from '@scfe-common/chain-tracker';
import { CustomActionType } from '@/utils/chain-tracker/plugins/types';

export default [
  {
    name: 'SLASortingWhileCheckingChain',
    status: {
      skuScanErrorCount: 0,
      gridNoScanErrorCount: 0,
      errorCount: 0,
    },

    collector: {} as TransactionCollector,

    // 耗时埋点
    /**
     * 全流程耗时
     */
    ALLName: 'custom_SortingWhileChecking',
    /**
     * 单个扫描 SKU 耗时
     */
    ScanSKU: 'custom_SortingWhileChecking_scan_SKU',
    /**
     * 扫描 GridNo 耗时
     */
    ScanGridNo: 'custom_SortingWhileChecking_scan_grid_no',

    // 新增各阶段错误数量埋点
    /**
     * SKU 扫描阶段错误数量
     */
    SKUScanErrorCount: 'custom_SortingWhileChecking_sku_scan_error_count',
    /**
     * SKU 扫描阶段错误数量
     */
    GridNoScanErrorCount:
      'custom_SortingWhileChecking_grid_no_scan_error_count',
    /**
     * 全流程错误数量
     */
    ErrorCount: 'custom_SortingWhileChecking_error_count',

    getPointList: function (): any[] {
      return [
        /**
         * 监听错误数量开始
         */
        // 监听 SKU 扫描请求报错
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/outbound\/sortwhilechecking\/(get_possible_sku_list|scan_sku)(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, _: any) => {
            const response = handleResponseData(trackData);
            if (response?.retcode !== 0) {
              this.status.skuScanErrorCount += 1;
            }
          },
        },
        // 监听 GridNo 扫描请求报错
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/outbound\/sortwhilechecking\/scan_grid_no(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, _: any) => {
            const response = handleResponseData(trackData);
            if (response?.retcode !== 0) {
              this.status.gridNoScanErrorCount += 1;
            }
          },
        },
        // 监听所有的请求报错
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/outbound\/sortwhilechecking\//,
            state: RequestState.After,
          },
          handler: (trackData: any, _: any) => {
            const response = handleResponseData(trackData);
            if (response?.retcode !== 0) {
              this.status.errorCount += 1;
            }
          },
        },
        /**
         * 监听错误数量结束
         */

        /**
         * 监听流程开始
         */
        // SortingWhileChecking任务开始：请求 Station ID 接口返回后
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/outbound\/sortwhilechecking\/scan_station_id(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData) => {
            // console.log('trackData', trackData);
            this.collector = DataCollectorInstance.createTransactionCollector();
            // 开始全流程耗时
            this.collector.startTrack({
              name: this.ALLName,
            });
            // 重置错误数量
            this.status.errorCount = 0;
            this.status.skuScanErrorCount = 0;
            this.status.gridNoScanErrorCount = 0;
          },
        },
        // 扫描 SKU 开始
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#scanSkuId',
          },
          handler: () => {
            this.collector.startTrack({
              name: this.ScanSKU,
            });
          },
        },
        // 扫描 SKU 结束
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/outbound\/sortwhilechecking\/scan_sku(\?.*)?$/,
            state: RequestState.After,
          },
          handler: () => {
            this.collector.endTrackByName({
              name: this.ScanSKU,
            });
          },
        },
        // 扫描 GridNo 开始
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#scanGridNo',
          },
          handler: () => {
            this.collector.startTrack({
              name: this.ScanGridNo,
            });
          },
        },
        // 扫描 GridNo 结束
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/outbound\/sortwhilechecking\/scan_grid_no(\?.*)?$/,
            state: RequestState.After,
          },
          handler: () => {
            this.collector.endTrackByName({
              name: this.ScanGridNo,
            });
          },
        },
        // SortingWhileChecking任务结束
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/outbound\/sortwhilechecking\/complete_checking_task(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);
            if (response?.retcode === 0) {
              // 全流程耗时上报
              const [allResult] = this.collector.endTrackByName({
                name: this.ALLName,
                isSuccess: true,
                endAll: true,
              });
              sendDataFn({
                pointId: allResult.name,
                customData: { ...allResult, type: 'experienceTime' },
              });

              // 上报全流程错误数量
              sendDataFn({
                pointId: this.ErrorCount,
                customData: {
                  errorCount_n: this.status.errorCount,
                  type: 'experienceCount',
                },
              });
              // 上报 SKU 扫描阶段错误数量
              sendDataFn({
                pointId: this.SKUScanErrorCount,
                customData: {
                  errorCount_n: this.status.skuScanErrorCount,
                  type: 'experienceCount',
                },
              });
              // 上报外包材扫描阶段错误数量
              sendDataFn({
                pointId: this.GridNoScanErrorCount,
                customData: {
                  errorCount_n: this.status.gridNoScanErrorCount,
                  type: 'experienceCount',
                },
              });
              DataCollectorInstance.removeTransactionCollector({
                traceId: this.collector.traceId,
              });
            }
          },
        },
        /**
         * 监听流程结束
         */
      ];
    },
  },
];
